export default "__VITE_ASSET__10664625__"